/**
 * ResourceAnalyticsService
 * Read-only aggregated analytics. Every endpoint reads from the pre-aggregated
 * SQL views + UsageLogDailySummary rollup — never from raw UsageLog.
 * Route: api/analytics
 */
import { BaseService } from '../base/BaseService';
export class ResourceAnalyticsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ResourceAnalyticsService.DEFAULT_SERVICE_PATH,
            basePath: ResourceAnalyticsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getCourseAnalytics(courseId, from, to) {
        const response = await this.getCourseAnalyticsRaw(courseId, from, to);
        return response.data ?? null;
    }
    getCourseAnalyticsRaw(courseId, from, to) {
        const q = [];
        if (from != null)
            q.push(`from=${from}`);
        if (to != null)
            q.push(`to=${to}`);
        const suffix = q.length ? `?${q.join('&')}` : '';
        return this.http.get(this.buildUrl(`course/${courseId}${suffix}`));
    }
    async getSessionAnalytics(sessionId) {
        const response = await this.http.get(this.buildUrl(`session/${sessionId}`));
        return response.data ?? null;
    }
    async getKBArticleAnalytics(articleId) {
        const response = await this.http.get(this.buildUrl(`kb-article/${articleId}`));
        return response.data ?? null;
    }
    async getMinistryAnalytics(ministryId, from, to) {
        const q = [];
        if (from != null)
            q.push(`from=${from}`);
        if (to != null)
            q.push(`to=${to}`);
        const suffix = q.length ? `?${q.join('&')}` : '';
        const response = await this.http.get(this.buildUrl(`ministry/${ministryId}${suffix}`));
        return response.data ?? null;
    }
    async getDeviceBreakdown(entityType, entityId) {
        const response = await this.http.get(this.buildUrl(`devices/${encodeURIComponent(entityType)}/${entityId}`));
        return response.data ?? [];
    }
}
ResourceAnalyticsService.DEFAULT_SERVICE_PATH = 'resources';
ResourceAnalyticsService.BASE_PATH = 'api/analytics';
//# sourceMappingURL=ResourceAnalyticsService.js.map